import { useLayoutEffect, useRef, useState } from "react";
import { useIsSmallScreen } from "./App";
import { OfficesOfTheDayView } from "./OfficesOfTheDayView";
import { getMorningAndEveningCelebrations } from "./calendar/ordinariate-calendar";
import { HORIZONTAL_RULE_COLOR } from "./tokens";
import { useSettings } from "./utils/settings";

export const FullCalendar = () => {
    const { settings, setSetting } = useSettings();

    const [scrolled, setScrolled] = useState(false);

    const [date, setDate] = useState(new Date());

    const isEpiphanyTransferred = settings.transferEpiphany === "yes";
    const isAscensionTransferred = settings.transferAscension === "yes";
    const isCorpusChristiTransferred = settings.transferCorpusChristi === "yes";

    const [regionsSwitchedOn, setRegionsSwitchedOn] = useState(
        new Set(localStorage.getItem("region-switches")?.split(";;;"))
    );
    const regionLabelsAllowed: string[] = [];
    regionsSwitchedOn.forEach((r) => regionLabelsAllowed.push(r));

    const year = getMorningAndEveningCelebrations(
        date.getFullYear(),
        isEpiphanyTransferred,
        isAscensionTransferred,
        isCorpusChristiTransferred,
        regionLabelsAllowed
    );

    const todayIndex = year.findIndex(
        (day) =>
            day.date === new Date().getDate() &&
            day.month === new Date().getMonth() + 1 &&
            day.year === new Date().getFullYear()
    );

    const [hour, setHour] = useState<"morning" | "evening">(
        new Date().getHours() > 12 ? "evening" : "morning"
    );

    const partOfYearToShow = year.filter((x) => x.year === date.getFullYear());

    const regionLabelsToShow: Set<string> = new Set();
    partOfYearToShow.forEach((day) => {
        day.regionLabels.forEach((regionLabel) => {
            regionLabelsToShow.add(regionLabel);
        });
    });
    const sortedRegionLabels: string[] = [];
    regionLabelsToShow.forEach((regionLabel) => {
        sortedRegionLabels.push(regionLabel);
    });
    sortedRegionLabels.sort();

    console.log(regionsSwitchedOn);

    const todayRef = useRef<HTMLDivElement>(null as any);

    useLayoutEffect(() => {
        if (!scrolled && todayRef.current) {
            setScrolled(true);
            setTimeout(() => {
                todayRef.current.scrollIntoView({ behavior: "smooth" });
            }, 1000);

            console.log("!!");
        }
    }, [scrolled]);

    return (
        <div>
            <div style={{ padding: useIsSmallScreen() ? 8 : 16 }}>
                <div
                    style={{
                        border: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                        borderRadius: 4,
                        overflow: "hidden",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#f4f4f4",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            columnGap: 12,
                            rowGap: 0,
                            justifyContent: "center",
                            padding: 8,
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "110%",
                            }}
                        >
                            Calendar
                        </div>
                        {sortedRegionLabels.map((regionLabel) => {
                            const isOn = regionsSwitchedOn.has(regionLabel);

                            return (
                                <div>
                                    <input
                                        type="checkbox"
                                        id={regionLabel}
                                        checked={isOn}
                                        onClick={() => {
                                            if (isOn) {
                                                regionsSwitchedOn.delete(
                                                    regionLabel
                                                );
                                            } else {
                                                regionsSwitchedOn.add(
                                                    regionLabel
                                                );
                                            }

                                            setRegionsSwitchedOn(
                                                new Set(regionsSwitchedOn)
                                            );

                                            const lsItems: string[] = [];
                                            regionsSwitchedOn.forEach((r) =>
                                                lsItems.push(r)
                                            );

                                            localStorage.setItem(
                                                `region-switches`,
                                                lsItems.join(";;;")
                                            );
                                        }}
                                    />
                                    <label
                                        htmlFor={regionLabel}
                                        style={{ paddingLeft: 4 }}
                                    >
                                        {regionLabel}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {partOfYearToShow.slice(1).map((day) => {
                        const isSelected =
                            day.date === date.getDate() &&
                            day.month === date.getMonth() + 1 &&
                            day.year === date.getFullYear();

                        return (
                            <div
                                style={{
                                    borderTop: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                                }}
                                ref={isSelected ? todayRef : undefined}
                            >
                                <OfficesOfTheDayView
                                    {...day}
                                    setDate={setDate}
                                    isSelected={isSelected}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
